import { useState } from 'react'
import { Dropdown } from '../../../components/ui/dropdown/Dropdown'
import { FilterIcon } from '../../../icons'
import { Button } from '../../../newComponents/Button/Button.tsx'
import Select from '../../../newComponents/forms/Select.tsx'
import { IGetAnswersFilter } from '../../../services/nextpeakClient/endpoints/getAnswers.ts'

enum ResponseType {
	MANAGER = 'manager',
	SELF = 'self',
	PEER = 'peer',
}

interface DropdownFilterProps {
  positions: { level: string }[]
	selectedFilters: IGetAnswersFilter
  updateLevelFilter: (level: string) => void
  updateResponseTypeFilter: (responseType: string) => void
  clearAllFilters: () => void
}

const responseTypeOptions = [
  { value: ResponseType.MANAGER, label: 'Manager' },
  { value: ResponseType.SELF, label: 'Self' },
  { value: ResponseType.PEER, label: 'Peer' },
]

export default function FilterDropdown({ selectedFilters, updateLevelFilter, positions, clearAllFilters, updateResponseTypeFilter }: DropdownFilterProps) {
  const [isOpen, setIsOpen] = useState(false)

  function toggleDropdown() {
    console.log(isOpen)
    setIsOpen(!isOpen)
  }

  function closeDropdown() {
    setIsOpen(false)
  }

  return (
    <div className="relative">
      <Button onClick={toggleDropdown} className="dropdown-toggle" size="sm" color="secondary">
				<span>Filters</span>
        <FilterIcon />
      </Button>

      <Dropdown
        isOpen={isOpen}
        onClose={closeDropdown}
        className="absolute right-0 flex w-[260px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark"
      >
        <div className="flex flex-col gap-1 pb-3 border-b border-gray-200 dark:border-gray-800">
          <Select placeholder="Select level" onChange={updateLevelFilter} selectedValue={selectedFilters.level} options={positions.map((position) => ({ value: position.level, label: position.level }))} />
          <Select placeholder="Select response type" onChange={updateResponseTypeFilter} selectedValue={selectedFilters.responseType} options={responseTypeOptions}/>
        </div>
        <Button onClick={clearAllFilters}>Clear</Button>
      </Dropdown>
    </div>
  )
}
